import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import { useEffect } from "react";
// import { VERSION_APP } from "./Utills/constants";s
// import liff from "@line/liff";

import BonusTime from "./Components/Main/Bonustime";
import BonusTimeAll from "./Components/Main/BonustimeAll";
import FootBall from "./Components/Main/Football";
import BonusTimeSecret from "./Components/Main/BonustimeSecret";
import LuckyNumber from "./Components/Main/luckyNumber";
import HuayAll from "./Components/Main/HuayAll";
import HuayThai from "./Components/Main/HuayThai";
import HuayLao from "./Components/Main/HuayLao";
import HuayMalay from "./Components/Main/HuayMalay";
import HuayHanoi from "./Components/Main/HuayHanoi";
import NotFound from "./Components/Main/NotFound";
function App() {

  // useEffect(() => {
  //   document.title = `LINE Official Message (v${VERSION_APP})`;
  // }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/bonustime"
          element={<BonusTime />}
        />

        <Route
          path="/football"
          element={<FootBall />}
        />

        <Route
          path="/bonustimeall"
          element={<BonusTimeAll />}
        />

        <Route
          path="/bonustimesecret"
          element={<BonusTimeSecret />}
        />

        <Route
          path="/luckynumber"
          element={<LuckyNumber />}
        />

        <Route
          path="/huayall"
          element={<HuayAll />}
        />

        <Route
          path="/huaythai"
          element={<HuayThai />}
        />

        <Route
          path="/huaylao"
          element={<HuayLao />}
        />

        <Route
          path="/huaymalay"
          element={<HuayMalay />}
        />

        <Route
          path="/huayhanoi"
          element={<HuayHanoi />}
        />

        <Route exact path="/" element={<BonusTime />} />
        {/* <Route path="/" element={<NotFound />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
